import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationResult, MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/AuthProvider';
import { loginPopupRequest } from './auth/AuthConfig';
import configureAppStore from './redux/store';
import PublicStockPage from './features/publicStock/PublicStockPage';

import { Providers } from '@microsoft/mgt-element';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';

const isPublicRoute = window.location.pathname.startsWith('/public/');

if (!isPublicRoute) {
    Providers.globalProvider = new Msal2Provider({
        publicClientApplication: msalInstance,
    });
}

const container = document.getElementById('root');
const root = createRoot(container!);

const ErrorComponent = (props: MsalAuthenticationResult) => <div>{props.error?.errorMessage}</div>;

if (isPublicRoute) {
    root.render(
        <React.StrictMode>
            <PublicStockPage />
        </React.StrictMode>,
    );
} else {
    root.render(
        <React.StrictMode>
            <Provider store={configureAppStore({})}>
                <MsalProvider instance={msalInstance}>
                    <MsalAuthenticationTemplate
                        interactionType={InteractionType.Redirect}
                        authenticationRequest={loginPopupRequest}
                        errorComponent={ErrorComponent}
                    >
                        <App />
                    </MsalAuthenticationTemplate>
                </MsalProvider>
            </Provider>
        </React.StrictMode>,
    );
}
